let swipers = {
    advantages: globalSwipers.advantages,
    bundles: {
        slider: false,
        elem: $('.js-slider-bundles'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            slidesPerView: 3,
            spaceBetween: 36,
            roundLengths: true,
            loop: false,
            watchOverflow: true,
            navigation: {
                nextEl: '.js-slider-bundles-next',
                prevEl: '.js-slider-bundles-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            pagination: {
                el: '.js-slider-bundles-pagination',
                type: 'bullets',
                clickable: true
            },
            on: {
                slideChange: function () {
                    bLazy.revalidate();
                },
            },
            breakpoints: {
                599: {
                    spaceBetween: 10,
                    slidesPerView: 'auto',
                    slidesOffsetBefore: 10,
                    slidesOffsetAfter: 10
                },
                767: {
                    spaceBetween: 10,
                    slidesPerView: 'auto',
                    slidesOffsetBefore: 15,
                    slidesOffsetAfter: 15
                },
                1365: {
                    spaceBetween: 24,
                    slidesPerView: 2,
                }
            }
        }
    },
    accessories: {
        slider: false,
        elem: $('.js-slider-accessories'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            slidesPerView: 3,
            spaceBetween: 36,
            roundLengths: true,
            loop: false,
            watchOverflow: true,
            navigation: {
                nextEl: '.js-slider-accessories-next',
                prevEl: '.js-slider-accessories-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            pagination: {
                el: '.js-slider-accessories-pagination',
                type: 'bullets',
                clickable: true
            },
            on: {
                slideChange: function () {
                    bLazy.revalidate();
                },
            },
            breakpoints: {
                599: {
                    spaceBetween: 10,
                    slidesPerView: 'auto',
                    slidesOffsetBefore: 10,
                    slidesOffsetAfter: 10
                },
                767: {
                    spaceBetween: 10,
                    slidesPerView: 'auto',
                    slidesOffsetBefore: 15,
                    slidesOffsetAfter: 15
                },
                1365: {
                    spaceBetween: 24,
                    slidesPerView: 2,
                }
            }
        }
    }
};

let variationSliders = [],
    alternativeSliders = [];

let selectedPresent = 0;

function alternativeSlidersInit() {
    $('.js-slider-alternatives').each(function(k, v) {
        const $sliderElem = $(this);

        alternativeSliders.push({
            slider: false,
            elem: $sliderElem,
            active: false,
            query: false,
            tooltipOpen: false,
            options: {
                slidesPerView: 1,
                roundLengths: true,
                loop: false,
                simulateTouch: false,
                allowTouchMove: false,
                watchOverflow: true,
                spaceBetween: 0,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                navigation: {
                    nextEl: $sliderElem.parent().find('.js-slider-alternatives-next'),
                    prevEl: $sliderElem.parent().find('.js-slider-alternatives-prev'),
                    disabledClass: 'is-disabled',
                    hiddenClass: 'is-hidden'
                },
                pagination: {
                    el: $sliderElem.parent().find('.js-slider-alternatives-pagination'),
                    type: 'bullets',
                    clickable: true,
                    dynamicBullets: true
                },
                on: {
                    slideChange: function () {
                        bLazy.revalidate();
                    },
                },
                breakpoints: {
                    599: {
                        spaceBetween: 10,
                        slidesPerView: 'auto',
                        slidesOffsetBefore: 10,
                        slidesOffsetAfter: -10,
                        simulateTouch: true,
                        allowTouchMove: true,
                    },
                    767: {
                        spaceBetween: 0,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                        simulateTouch: true,
                        allowTouchMove: true,
                    }
                }
            }
        });

        checkSlider(alternativeSliders[k]);

        $(window).on('resize', function () {
            checkSlider(alternativeSliders[k]);
        });
    });
}

function toggleDescLink($elem) {
    var $wrapper = $elem.find(".toggle_text__wrapper"),
        max_height = $wrapper.height(),
        real_height = $wrapper.children("div").height(),
        $link = $elem.find(".link__more");

    if (!$wrapper.hasClass("full")) {
        if (real_height > max_height) {
            $wrapper.addClass('is-collapsed');
            $link.show();
        }
    }
}

function createStars($elem, options) {
    $elem.starRating($.extend({}, {
        starSize: 16,
        initialRating: $elem.attr('data-stars') * 5 / 100,
        readOnly: false,
        starShape: 'rounded',
        emptyColor: '#E0EBF5',
        activeColor: '#F8C81C',
        hoverColor: '#F8C81C',
        ratedColor: '#F8C81C',
        useGradient: false,
        disableAfterRate: false
    }, options));
}

function productDetailVariationChange(data) {
    const product = data.product;
    const isSet = $('.detail-main__heading').hasClass('is-set');

    $(document).find('.js-set-item-image[data-id="' + product.id + '"]')
        .attr('src', Eshop.image(data.product.image, 'sm'))
        .attr('data-src', Eshop.image(data.product.image, 'sm'))
        .attr('data-price', product.price_vat);

    $('.js-club-discount-price').text(Format.price(data.response.item.club_discount_amount));
    if (!isSet) {
        $('.js-product-detail-short-description').html(data.response.variation.product.short_description);
        $('.js-product-detail-short-description').shorten({
            showChars: 140,
            ellipsesText: '...',
            moreText: $('.js-product-detail-short-description').data('more-text'),
            lessText: $('.js-product-detail-short-description').data('less-text')
        });
    }
    $('.js-product-detail-description[data-id="' + data.response.variation.product.id + '"]').html(data.response.variation.product.description);

    $('.js-gallery-main[data-id="' + product.id + '"]')
        .attr('src', Eshop.image(product.image, 'lg'))
        .attr('data-src', Eshop.image(product.image, 'lg'))
        .attr('data-variation-id', product.product_variation_id);

    $('.js-ribbon-item.is-exposed')
        .toggleClass('hidden', !data.response.variation.custom_is_exposed_at_store);

    $('.js-detail-availability')
        .css('color', product.status_color)
        .html(product.status);

    if (product.status_color === null) {
        // remove color css style from .js-detail-availability element
        $('.js-detail-availability').css('color', '');
    }

    if (product.status_description && !data.response.variation.delivery_date && !data.response.variation.product.delivery_date && Object.keys(data.response.item.shipping_delivery_info).length === 0) {
        $('.js-detail-availability').append('<i class="ico ico-question js-tippy" title="' + product.status_description + '"></i>');

        tippy('.js-tippy', {
            arrow: true
        });
    } else if (Object.keys(data.response.item.shipping_delivery_info).length > 0 && data.response.item.is_available) {
        var detailDeliveries = '';
        var first = false;

        $.each(data.response.item.shipping_delivery_info, function (key, value) {
            if (first) {
                detailDeliveries += ' / ';
            } else {
                first = true;
            }

            detailDeliveries += value.text
        });

        $('.js-detail-deliveries').show();
        $('.js-detail-deliveries').html(detailDeliveries);
    } else {
        $('.js-detail-deliveries').hide();
    }

    if (data.response.item.shipping_delivery_info === false) {
        $('.js-detail-deliveries').hide();
    }

    if (data.response && data.response.variation && data.response.variation.weight) {
        $('.js-product-weight').each(function() {
            var unit = $(this).data('unit');

            $(this).text(parseFloat(data.response.variation.weight).toFixed(2).replace('.', ',') + ' ' + unit);
        });
    }

    if (data.response.discounts && data.response.discounts.length > 0) {
        data.response.discounts.forEach(function(discount) {
            const $discountItem = $(`.js-discount-item[data-promotion-id="${discount.id}"]`);

            if ($discountItem.length) {
                $discountItem.find('.productDiscount').attr('data-price', data.response.variation.price_vat);
                $discountItem.find('.productDiscount strong').text(Format.price(discount.price));
            }
        });
    }

    $('.js-product-item-set').each(function() {
        var bundlePrice = $(this).find(".js-bundle-price").attr('data-price'),
            oldPrice = 0,
            saving = 0,
            discount = parseFloat($(this).attr("data-discount")),
            rounding = $(this).attr("data-rounding"),
            url = $(this).attr("href"),
            parts = {},
            tmp = url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
                parts[key] = value;
            });

        parts["variations[" + data.response.variation.product_id + "]"] = data.response.variation.id;

        url = url.split("?")[0];
        query = Object.keys(parts).map(function(k) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(parts[k])
        }).join("&");

        $(this).attr("href", url + "?" + query);;

        $(this).find('.js-set-item-image').each(function() {
            oldPrice += parseFloat($(this).attr("data-price"));
        });

        if ($(this).attr("data-discount") != 'price') {
            bundlePrice = calculateDiscountPrice(oldPrice, discount, rounding);
            $(this).find(".js-bundle-price")
                .text(Format.price(bundlePrice))
                .attr('data-price', bundlePrice);
        }

        saving = oldPrice - bundlePrice;

        $(this).find(".js-bundle-saving").text(Format.price(saving));
    });

    if ($('.js-tippy-set-status').length > 0) {
        if ($('.js-tippy-set-status')[0]._tippy) {
            $('.js-tippy-set-status')[0]._tippy.destroy();

            setTimeout(function() {
                tippy('.js-tippy-set-status', {
                    arrow: true,
                    theme: 'set'
                });
            }, 250);
        }
    }
}

function calculateDiscountPrice(price, discount, rounding) {
    if (discount > 0) {
        price = price - (price * (discount / 100));
    }

    if (rounding == "round") {
        price = Math.round(price);
    }

    if (rounding == "ceil") {
        price = Math.ceil(price);
    }

    if (rounding == "floor") {
        price = Math.floor(price);
    }

    return price;
}

rEvent.on("Product.variationChanged", function (data) {
    if (data.response.status) {
        productDetailVariationChange(data);
    } else {
        Eshop.alert(data.response.message, {'type': 'danger'});
    }
});

rEvent.on('Product.variationMounted', function() {
    $('.js-slider-variations').each(function(k, v) {
        const $sliderElem = $(this);

        variationSliders.push({
            slider: false,
            elem: $sliderElem,
            active: false,
            query: 'cxs;xs',
            options: {
                slidesPerView: 6,
                spaceBetween: 22,
                loop: false,
                threshold: 10,
                roundLengths: true,
                navigation: {
                    nextEl: $sliderElem.parent().find('.js-slider-variations-next'),
                    prevEl: $sliderElem.parent().find('.js-slider-variations-prev'),
                    disabledClass: 'is-disabled',
                    hiddenClass: 'is-hidden'
                },
                breakpoints: {
                    399: {
                        slidesPerView: 3
                    },
                    479: {
                        slidesPerView: 4
                    },
                    599: {
                        slidesPerView: 5
                    },
                    699: {
                        slidesPerView: 6
                    }
                }
            }
        });

        checkSlider(variationSliders[k]);

        if (checkResolution('cxs;xs')) {
            const selectedIndex = $sliderElem.find('.is-selected').parent().index();

            variationSliders[k].slider.slideTo(selectedIndex);
        }

        $(window).on('resize', function () {
            checkSlider(variationSliders[k]);
        });
    });
});

function checkNotificationType($elem) {
    var isCheaper = $elem.find("[name=\"notification_type\"]").val() == "become_cheaper",
        $price_input = $elem.find(".watchdog_price");

    if (isCheaper) {
        $price_input.slideDown();
    } else {
        $price_input.slideUp();
    }
}

function floatingBoxInit() {
    const $box = $('.js-gallery'),
        $boxWrapper = $box.parent();

    floatingBoxFloat($box, $boxWrapper);

    $(window).on('scroll resize', function() {
        floatingBoxFloat($box, $boxWrapper);
    });

    rEvent.on("Product.variationChanged", function (data) {
        floatingBoxFloat($box, $boxWrapper);
    });
}

function floatingBoxFloat($box, $boxWrapper) {
    if (checkResolution('sm;md;lg')) {
        const windowTopOffset = $(document).scrollTop(),
            boxWrapperTopOffset = $boxWrapper.offset().top,
            boxWrapperWidth = $boxWrapper.width(),
            boxHeight = $box.outerHeight(),
            scrollOffset = 30;

        let boxWrapperHeight = 0;

        $boxWrapper.siblings().each(function() {
            if (!$(this).hasClass('is-set')) {
                boxWrapperHeight += $(this).height();
            }
        });

        if (boxWrapperHeight > boxHeight) {
            $boxWrapper.css('height', boxWrapperHeight);
            $box.addClass('is-absolute');

            // Scroll okna plus offset elementu od vrcho pri scrolle v pixeloch
            boxStartScroll = windowTopOffset + scrollOffset,
            // odsadenie elementu od vrchu plus vyska wrapperu minus vyska floatovacieho okna
            boxEndScroll = boxWrapperTopOffset + boxWrapperHeight - boxHeight;

            // Ak je scroll okna vacsi ako vrchna pozicia wrapperu floatovacieho boxu
            // a zaroven je scroll okna mensi ako vrchna pozicia wrapperu floatovacieho boxu
            // plus celkova velkost wrapperu floatovacieho okna minus velkost floatovacieho okna
            // vtedy sa prida position fixed

            if (boxStartScroll > boxWrapperTopOffset && boxStartScroll < boxEndScroll) {
                $box.css('top', scrollOffset).css('width', boxWrapperWidth);
                $box.addClass('is-fixed');

            // Ak je scroll okna vacsi ako finalna scrollovacia poziciia vtedy sa floatovaci box
            // posunie uplne na spodok wrapperu

            } else if (boxStartScroll > boxEndScroll) {
                $box.css('top', boxEndScroll - boxWrapperTopOffset).css('width', '');
                $box.removeClass('is-fixed');

            // Ak je scroll okna mensi ako vrchna pozicia wrapper, vtedy sa floatovaci box posunie
            // uplne na vrch wrapperu

            } else if (boxStartScroll < boxWrapperTopOffset) {
                $box.css('top', boxWrapperTopOffset - boxWrapperTopOffset).css('width', '');
                $box.removeClass('is-fixed');
            }
        } else {
            $boxWrapper.css('height', boxHeight);
            $box.removeClass('is-absolute').removeClass('is-fixed');
        }
    } else {
        $boxWrapper.css('height', '');
        $box.removeClass('is-absolute').css('width', '').css('top', '').removeClass('is-fixed');
    }
}

$(function() {
    floatingBoxInit();
    alternativeSlidersInit();

    tippy('.js-tippy-set-status', {
        arrow: true,
        theme: 'set'
    });

    tippy('.js-tippy-custom', {
        arrow: true,
        interactive: true,
        trigger: 'manual',
        html: '#price-request-tippy-content'
    });

    $.each(swipers, function(k, v) {
        if (this.elem.first().find('.swiper-slide').length < 2) {
            delete swipers[k];
        }
    });

    checkSliders(swipers);

    $(window).on('resize', function () {
        checkSliders(swipers);
    });

    $("[name=\"productQuestionForm\"]").validate({
        rules: {
            "email": {
                email: true
            }
        }
    });

    $(".toggle_text").each(function(){
        toggleDescLink($(this));
    });

    $("a[data-toggle=\"tab\"]").on("shown.bs.tab", function (e) {
        $(".toggle_text").each(function(){
            toggleDescLink($(this));
        });

        bLazy.revalidate();
    });

    $("body").on("click", ".toggle_text .link__more", function(event){
        var $this = $(this),
            $desc = $this.siblings(".toggle_text__wrapper");

        event.preventDefault();

        $desc.toggleClass('is-collapsed');
        $desc.addClass("full");
        $this.hide();
    });

    $('.js-gallery').lightGallery(
        $.extend({}, lightGallerySettings, {
            thumbnail: true,
            selector: '.js-lightbox',
            exThumbImage: 'data-thumb',
            galleryId: 1
        })
    );

    $('.js-gallery-more, .js-gallery-main').on('click', function(e) {
        e.preventDefault();

        const id = $(this).attr('data-id') || 0;
        const variationId = $(this).attr('data-variation-id') || 0;
        const $galleryLightboxItems = $('.js-gallery').find('.js-lightbox');
        let $item = $galleryLightboxItems.first();

        for (let index = 0; index < $galleryLightboxItems.length; index++) {
            const $galleryLightboxItem = $galleryLightboxItems.eq(index);

            if (
                $galleryLightboxItem.data('id') == id &&
                $galleryLightboxItem.data('variations-ids').some(
                    (dataVariationId) => dataVariationId == variationId
                )
            ) {
                $item = $galleryLightboxItem;
                break;
            }
        }

        $item.trigger('click');
    });

    $(document).on('click', function(event) {
        const $popup = $(".js-wishlist-popup");

        if ($popup.is(':visible') && !$(event.target).closest('.js-product-action-wishlist').size()) {
            $popup.hide();
        }
    });

    // wishlist okienko
    $(".js-wishlist-trigger").on("click", function(event) {
        var $popup = $(".js-wishlist-popup");

        event.preventDefault();

        $popup.toggle();
    });

    $('.js-wishlist-new-trigger').on('click', function(event) {
        var $this = $(this),
            $form = $('.js-wishlist-new');

        event.preventDefault();

        $this.hide();
        $form.slideDown(200);
        $form.find('.js-wishlist-popup-new-input').focus();
    });

    $('.js-wishlist-popup-list').on('change', '.js-wishlist-popup-checkbox', function() {
        var $this = $(this),
            wishlistId = $this.val(),
            addUrl = $this.data('add-url'),
            deleteUrl = $this.data('delete-url'),
            productId = $this.data('product-id'),
            isChecked = $this.is(':checked')
            url = isChecked ? addUrl : deleteUrl;

        $this.prop('disabled', true);

        $.post(url, {product_id: productId, customer_wishlist_id: wishlistId}, function(data) {
            Eshop.alert(data.message, {type: data.status ? 'success' : 'error'});
            $this.prop('disabled', false);
        }, "json");
    });

    $('.js-form-wishlist-create').validate({
        submitHandler: function(form) {
            $(form).find('button[type="submit"]').prop('disabled', true);

            Form.ajaxPost(form, function(data) {
                if (data.status) {
                    var $popup = $('.js-wishlist-popup'),
                        $list = $('.js-wishlist-popup-list'),
                        $input = $(form).find('.js-wishlist-popup-new-input'),
                        $form = $('.js-wishlist-new'),
                        $link = $('.js-wishlist-new-trigger'),
                        wishlist_name = $input.val(),
                        $item = $list.find('.js-wishlist-popup-item').eq(0);

                    if ($item.hasClass('is-empty')) {
                        $item.removeClass('is-empty');
                    } else {
                        $item = $item.clone();
                    }

                    if ($popup.hasClass('is-empty')) {
                        $popup.slideDown(200);
                        $popup.removeClass('is-empty');
                    }

                    $link.show();
                    $form.slideUp(200);

                    $input.val('');
                    $(form).find('button[type="submit"]').prop('disabled', false);

                    $item
                        .find('.js-wishlist-popup-checkbox')
                            .prop('disabled', false)
                            .prop('checked', true)
                            .attr('id', 'wish_' + data.wishlist_id)
                            .val(data.wishlist_id)
                            .end()
                        .find('label')
                            .html(wishlist_name)
                            .attr('for', 'wish_' + data.wishlist_id)
                            .end()
                        .prependTo($list.find('form').first());

                    $list.animate({
                        scrollTop: 0
                    }, 200);
                }

                Eshop.alert(data.message, {type: data.status ? 'success' : 'error'});
            }, 'json');
        }
    });

    $('.js-stars').each(function() {
        createStars($(this), {
            readOnly: true,
            starSize: parseInt($(this).attr('data-size')) || 16
        });
    });

    $('.js-collapse-content').each(function() {
        $(this).shorten({
            showChars: parseInt($(this).data('show-chars')) || 140,
            ellipsesText: '...',
            moreText: $(this).data('more-text')
        });
    });

    $('.js-product-collapse-content').shorten({
        showChars: 140,
        ellipsesText: '...',
        moreText: $('.js-product-collapse-content').data('more-text'),
        lessText: $('.js-product-collapse-content').data('less-text')
    });

    /*$('.js-product-collapse-content').on('click', '.morelink', function (event) {
        event.preventDefault();
        event.stopPropagation();

        $('.detail-tabs__nav').find('a[href="#section_product_description"]').tab('show');
        $('.js-detail-tabs').slideHere(0);
    });*/

    $('.js-detail-tabs-trigger').on('shown.bs.tab', function (e) {
        $('.js-detail-tabs-trigger').removeClass('is-active');
        $(e.target).addClass('is-active');

        setTimeout(function() {
            slideTo($(e.target), -5, 200);
        }, 5);
    });

    $('.js-detail-tabs-trigger').on('click', function(e) {
        if ($(this).hasClass('is-active')) {
            e.preventDefault();
            e.stopPropagation();

            $(this).removeClass('is-active');
            $(this).next('.tab-pane').removeClass('active');
        }
    });

    $('.js-bundle-tab').on('shown.bs.tab', function(e) {
        const id = $(this).data('id');

        e.preventDefault();

        $('.js-bundle-tab[data-id="' + id + '"]').not('.active').each(function() {
            $(this).find('a').tab('show');
        });
    });

    $("#watchdog-modal form[name=\"watchdog\"]").validate({
        rules: {
            customer_email: {
                email: true
            },
            notification_price: {
                number: true
            }
        },
        submitHandler: function(form) {
            $("#watchdog-modal").find(".mod-error").hide();

            Form.ajaxPost(form, function(data) {
                var msg = data.msg.format;
                if (!msg) {
                    msg = data.msg;
                }

                if (data.status) {
                    $("form[name=\"watchdog\"]").fadeOut(250, function(){
                        $("#watchdog-modal .mod-success .c-msg span").text(msg);
                        $("#watchdog-modal .mod-success").fadeIn(250);
                    });
                } else {
                    $("#watchdog-modal").find(".mod-error")
                        .text(msg)
                        .fadeIn(250);
                }
            }, "json");
        }
    });

    createStars($('.js-rating-stars'), {
        starSize: 20,
        useFullStars: true,
        initialRating: 5,
        callback: function(currentRating, $el){
            $('.js-rating-form').find('input[name="rating"]').val(currentRating);
        }
    });

    $('.js-rating-form').validate({
        submitHandler: function(form) {
            $(form).find('[type="submit"]')
                .prop('disabled', true)
                .addClass('is-loading');

            window.assignRecaptchaResponseToForm(form).then(function() {
                Form.ajaxPost(form, function(data) {
                    $('.js-rating-error').slideUp();

                    if (!data.status) {
                        $('.js-rating-error').text(data.message).slideDown();
                    } else {
                        $('.js-rating-form').fadeOut(250, function(){
                            $('.js-rating-success').fadeIn(250);
                        });
                    }

                    $(form).find('[type="submit"]')
                        .prop('disabled', false)
                        .removeClass('is-loading');
                }, 'json');
            });
        }
    });

    checkNotificationType($("#watchdog-modal"));

    $("#watchdog-modal").find("[name=\"notification_type\"]").bind("change", function() {
        checkNotificationType($("#watchdog-modal"));
    });

    $('.js-price-request-form').validate({
        submitHandler: function(form) {
            $('.js-price-request-submit').prop('disabled', true).addClass('is-loading');
            $('.js-price-request-error').slideUp(150);

            window.assignRecaptchaResponseToForm(form).then(function() {
                Form.ajaxPost(form, function(data) {
                    $('.js-price-request-submit').prop('disabled', false).removeClass('is-loading');

                    if (data.status) {
                        $('.js-price-request-hide').slideUp(250);
                        $('.js-price-request-success').slideDown(250);
                    } else {
                        $('.js-price-request-error').html(data.message).slideDown(250);
                    }
                }, 'json');
            });
        }
    });

    $('.js-no-price-request-form').validate({
        submitHandler: function(form) {
            $('.js-no-price-request-submit').prop('disabled', true).addClass('is-loading');
            $('.js-no-price-request-error').slideUp(150);

            window.assignRecaptchaResponseToForm(form).then(function() {
                Form.ajaxPost(form, function(data) {
                    $('.js-no-price-request-submit').prop('disabled', false).removeClass('is-loading');

                    if (data.status) {
                        $('.js-no-price-request-hide').slideUp(250);
                        $('.js-no-price-request-success').slideDown(250);
                    } else {
                        $('.js-no-price-request-error').html(data.message).slideDown(250);
                    }
                }, 'json');
            });
        }
    });

    $('.js-detail-tabs-item').on('click', function() {
        $(this)
            .siblings()
            .removeClass('active');
    });
});

function checkSelectionForPriceRequest(event)  {
    const selection = document.getSelection();

    if (selection.anchorNode == null || selection.focusNode == null) {
        return;
    }

    const anchorNode = selection.anchorNode.parentElement;
    const focusNode = selection.focusNode.parentElement;
    const isHighlighted = anchorNode.classList.contains('js-tippy-custom') && focusNode.classList.contains('js-tippy-custom');

    if (isHighlighted && !selection.isCollapsed) {
        if (event.target._tippy && !event.target._tippy.state.visible) {
            setTimeout(function() {
                event.target._tippy.show();
            }, 0);
        }
    }
}

document.addEventListener('mouseup', checkSelectionForPriceRequest);
document.addEventListener('touchend', checkSelectionForPriceRequest);